import {Controller} from "stimulus"
import InView from "./../utils/InView"

export default class extends Controller {

    static targets = [
        "content",
    ]

    initialize() {
      let heightContent = this.contentTarget.offsetTop + this.contentTarget.offsetHeight

        this.contentfixedClassAdded = false
        new InView({
            element: this.contentTarget,
            withDirection: true,
            windowPosition: "top",
            withThrottle: false,
            inViewCallback: () => {
                console.log("bitch")
                if (!this.contentfixedClassAdded) {
                    this.contentTarget.classList.add("is-fixed")
                    this.contentfixedClassAdded = true
                }
            },
            positionReference: () => heightContent,
            positionReferenceBack: () => 300,
        })
    }
}
